/**
 * Vuetamin thread names.
 */
export default {
  BRUSH: 'brush',
  POINT: 'point',
  SLIDE: 'slide',
  STATE: 'state',
  TOOLS: 'tools',
  SIZES: 'sizes',
  BRUSH_RADIUS: 'brushRadius',
  BRUSH_OPACITY: 'brushOpacity',
  BRUSH_HARDNESS: 'brushHardness',
  BRUSH_COLOR: 'brushColor',
  LAZYRADIUS: 'lazyRadius',
  DISTANCE: 'distance',
  CONNECTION: 'connection'
}
